/**
 * SEOMainContainer
 * --
 */
import React from 'react';
import SEOMainPresenter from './SEOMainPresenter';

const SEOMainContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <SEOMainPresenter />
    </>
  );
};

export default SEOMainContainer;
